/* Country/currency picker behaviour, shared by the navbar and the footer.

   This used to live inline in the navbar section, which meant the footer's picker was
   dead on any page where the navbar is hidden (the home page, by default). Loading it
   once from the layout makes both pickers work wherever either one renders.

   Flags themselves are pure CSS (assets/gurbet-flags.css keyed on [data-gb-flag]). */
(function () {
  if (window.__gbLocalization) return;
  window.__gbLocalization = true;

  function closeAll(except) {
    document.querySelectorAll('[data-gb-cs]').forEach(function (cs) {
      if (cs === except) return;
      cs.classList.remove('is-open');
      var t = cs.querySelector('.gb-cs-toggle');
      var l = cs.querySelector('.gb-cs-list');
      if (t) t.setAttribute('aria-expanded', 'false');
      if (l) l.hidden = true;
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.gb-cs-toggle');
    if (toggle) {
      var cs = toggle.closest('[data-gb-cs]');
      var list = cs && cs.querySelector('.gb-cs-list');
      if (!cs || !list) return;
      var open = cs.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      list.hidden = !open;
      closeAll(cs);
      if (open) keepOnScreen(cs, list);
      return;
    }
    if (!e.target.closest('[data-gb-cs]')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* The footer picker sits at the bottom of the page, so its list has to open upward
     or it would be clipped off-screen. Decide per-open from real measurements. */
  function keepOnScreen(cs, list) {
    list.style.bottom = '';
    list.style.top = '';
    var toggle = cs.querySelector('.gb-cs-toggle');
    if (!toggle) return;
    var r = toggle.getBoundingClientRect();
    var spaceBelow = window.innerHeight - r.bottom;
    var needed = Math.min(list.scrollHeight + 16, 340);
    if (spaceBelow < needed && r.top > spaceBelow) {
      list.style.bottom = '100%';
      list.style.marginBottom = '8px';
      list.style.marginTop = '0';
    } else {
      list.style.marginTop = '8px';
      list.style.marginBottom = '0';
    }
  }
})();
